var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecretsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4953 8.47633C9.87057 6.70109 8.17914 5.42871 6.19057 5.42871C3.66866 5.42871 1.61914 7.47823 1.61914 10.0001C1.61914 12.522 3.66866 14.5716 6.19057 14.5716C8.17914 14.5716 9.87057 13.2992 10.4953 11.5239H13.8096V14.5716H16.8572V11.5239H18.381V8.47633H10.4953ZM6.19057 11.5239C5.35247 11.5239 4.66676 10.8382 4.66676 10.0001C4.66676 9.16204 5.35247 8.47633 6.19057 8.47633C7.02866 8.47633 7.71438 9.16204 7.71438 10.0001C7.71438 10.8382 7.02866 11.5239 6.19057 11.5239Z",
    fill: "#2E87D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecretsIcon);
export default __webpack_public_path__ + "static/media/secretsIcon.3422530d337968b67c37227cdea6d5ad.svg";
export { ForwardRef as ReactComponent };